export const KEY_FEATURES = {
  country: localStorage.getItem('hik_connect_pro_country') * 1,
  // 当前需要展示4G介绍页的欧洲国家
  countriesList: [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 13, 14, 15, 16, 17, 19, 21, 22, 27, 52, 56, 75, 109, 110, 128, 164, 207]
};
